<div class="popup-container tlms-popup">
	<header>
		<div class="header" style="display:block">{{heading}} Task</div>
		<button class="close" style="top:-3px" (click)="close()">
			<mat-icon>close</mat-icon>
		</button>
	</header>
	<ng-container>
		<div style="padding: 16px 24px 16px 24px;">
			<div class="col-12" style="width: 100%;">
				<div class="body">
					<div class="content-line">
						<label class="catlabel">Task ID:</label>
						<span class="content-text">
							{{ taskID }}
						</span>
					</div>
					<div class="content-line">
						<label class="catlabel">Description:
							<span style="color:#ff0000">*</span>
						</label>
						<span class="content">
							<input type="text" id="desc" name="desc" required minlength="4" maxlength="255" class="desc"
								[(ngModel)]="description">
						</span>
					</div>
					<div class="content-line">
						<label class="catlabel">Category:
							<!-- <span style="color:#ff0000">*</span> -->
						</label>
						<span class="content">
							<mat-form-field appearance="outline" class="fixed-select">
								<mat-select [(ngModel)]="selectedCategory" panelClass="custom-cat-panel"
									[disableOptionCentering]="true" placeholder="Select">
									<!-- Sticky search input -->
									<mat-option>
										<ngx-mat-select-search [formControl]="catFilterControl"
											placeholderLabel="Search categories" noEntriesFoundLabel="No category found"
											style="width: 100%;">
										</ngx-mat-select-search>
									</mat-option>
									<mat-option *ngFor="let cat of filteredCategories | async" [value]="cat">
										{{ cat.label }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</span>
					</div>
					<div class="content-line">
						<label class="catlabel">Operating Procedure:
						</label>
						<span class="content">
							<mat-form-field appearance="outline" class="fixed-select">
								<mat-select [(ngModel)]="selectedOP" [ngModelOptions]="{ standalone: true }"
									panelClass="custom-op-panel" placeholder="Select" [disableOptionCentering]="true">
									<mat-option>
										<ngx-mat-select-search [formControl]="opFilterControl"
											placeholderLabel="Search OPs" noEntriesFoundLabel="No entry found"
											style="width: 100%;">
										</ngx-mat-select-search>
									</mat-option>
									<!-- Options list -->
									<div style="max-height: 200px; overflow-y: auto;min-width:300px">
										<mat-option *ngFor="let op of filteredOPDropdown | async" [value]="op">
											{{ op.label }}
										</mat-option>
									</div>
								</mat-select>
							</mat-form-field>
						</span>
					</div>
				</div>
				<label *ngIf="enableError" class="errormsg"> {{errormsg}} </label>
			</div>
		</div>
		<div class="cfooter d-flex justify-content-between align-items-center popup-footer">
			<button (click)="onNoClick()" class="mCancel"> CANCEL
			</button>
			<button class="taskm-submit" style="display: inline" (click)="saveClick()">
				SAVE
			</button>
		</div>
	</ng-container>
</div>